import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';

import DownloadIcon from 'images/icons/downloadUpload/downloadIconGray.svg';
import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';

import { HeaderCell, Cell, IconDownload } from '../style';

const environments = Environment(process.env.REACT_APP_ENV);

function PurchaseHistoryModal({ open, onClose, historyData = [] }) {
  const handleDownloadOrder = async (orderId) => {
    try {
      const response = await fetch(
        `${environments.catalog}/shopping/orders/${orderId}/xls`
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `pedido-${orderId}.xls`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao baixar o pedido:', error);
      console.log('Erro ao baixar o pedido');
    }
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="sm"
          className="defaultModal productTableDialog"
          PaperProps={{
            style: {
              width: '443px',
              height: '283px',
              borderRadius: '8px'
            }
          }}
        >
          <DialogTitle
            className="modalHeader bold textAlignCenter cursorMove"
            style={{ paddingRight: '12px', backgroundColor: '#1F2445' }}
          >
            <Typography>
              <b>PEDIDOS GERADOS</b>
            </Typography>
            <IconButton
              edge="start"
              onClick={onClose}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <img style={{ width: '12px' }} src={CloseIconNavy} alt="Close" />
            </IconButton>
          </DialogTitle>

          <DialogContent className="modalContent onlyTableProducts pt0 pb0">
            <table
              className="purchaseTable"
              style={{ width: '100%', borderCollapse: 'collapse', margin: '0' }}
            >
              <thead>
                <tr >
                  <HeaderCell className="paddingY">
                    <span>DATA</span>
                  </HeaderCell>
                  <HeaderCell className="borderLGray center paddingY" >
                    <span>PRODUTOS</span>
                  </HeaderCell>
                  <HeaderCell className="borderLGray paddingY">&nbsp;</HeaderCell>
                </tr>
              </thead>
              <tbody>
                {historyData.map((item, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #D2D3D7', paddingTop: '5px' }}>
                    <Cell className="description left colData">
                      <span className="navyText">{item.date}</span>
                    </Cell>
                    <Cell
                      className="description borderLGray right"
                    >
                      <span className="blackText">{item.products}</span>
                    </Cell>
                    <Cell
                      className="description borderLGray"
                      style={{ textAlign: 'center'}}
                    >
                      <IconDownload
                        onClick={() => handleDownloadOrder(item.id)}
                        style={{ padding: '4px 0 4px 0' }}
                      >
                        <img
                          src={DownloadIcon}
                          alt="Download"
                          style={{
                            width: '12px',
                            height: '12px'              
                          }}
                        />
                      </IconDownload>
                    </Cell>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
}

export default PurchaseHistoryModal;
